import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from '@tanstack/react-query';
import { Automation } from '../types';
import automationsAPI from 'api/automationsAPI';
import { automationQueries } from 'queryKeys/automations';

export const useAutomationMutations = (
  roleId: number,
  options: Omit<UseMutationOptions<Automation[], unknown, Automation[], unknown>, 'mutationFn'> = {}
): UseMutationResult<Automation[], unknown, Automation[], unknown> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => automationsAPI.save(payload, roleId),
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: automationQueries.automations.list(roleId).queryKey,
      });

      options.onSuccess?.(data, variables, context);
    },
  });
};
